import type { InviteResult, OrgMember, OrgRole, SeatStatus } from "@/types/api";
import { http } from "./http";

/** The roster: who holds a seat, who was invited, who was removed. */
export const membersService = {
	list: (filters: { seatStatus?: SeatStatus } = {}, signal?: AbortSignal) =>
		http.get<{ members: OrgMember[]; seats: InviteResult["seats"] }>(
			"/api/org/members",
			{ query: { seatStatus: filters.seatStatus }, signal },
		),

	/**
	 * Invite one person or a pasted list. The Gateway returns a per-email
	 * breakdown, so a single bad address never sinks the batch.
	 */
	invite: (emails: string[], role: Exclude<OrgRole, "owner"> = "member") =>
		http.post<InviteResult>("/api/org/members", { emails, role }),

	/**
	 * Deactivate. Frees the seat immediately and ends the member's access on
	 * their next request; the row is kept and their learning history is
	 * untouched.
	 */
	deactivate: (memberId: string) =>
		http.del<{ ok: true; seats: InviteResult["seats"] }>(
			`/api/org/members/${memberId}`,
		),

	/** Role change. Owner-only on the Gateway; the UI should reflect that. */
	setRole: (memberId: string, role: OrgRole) =>
		http.patch<{ ok: true }>(`/api/org/members/${memberId}`, { role }),
};
